<template>
    <div class="title-wrapper">
        <div class="back">
            <p><span @click="emitter(path)">{{title}}</span></p>
        </div>
        <div class="jump" v-if="title2">
            <p><span @click="emitter(path2)">{{title2}}</span></p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'base-title',
    props: {
        title: {
            require: false,
            default: '返回',
        },
        path: {
            require: false,
            default: '',
        },
        title2: {
            require: false,
            default: '',
        },
        path2: {
            require: false,
            default: '',
        },
    },
    created() {},
    data() {
        return {}
    },
    methods: {
        emitter: function (path) {
            if (!path) {
                this.$router.push('/')
            } else if (path == '-1') {
                // this.$router.go(-1);
               this.$router.back();
            } else {
                this.$router.push(path)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
    position: relative;
    width: 100%;
    height: 0.36rem;
    margin: 0.35rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .back {
        width: 50%;
        height: 0.36rem;
        position: relative;
        p {
            width: auto;
            vertical-align: middle;
            color: #c39b5e;
            font-size: 0.36rem;
            height: 0.36rem;
            line-height: 0.36rem;
            text-align: left;
            padding-left: 0.67rem;
            font-weight: bold;
        }

        &::before {
            width: 0.26rem;
            height: 0.36rem;
            background: url(~@/assets/img/back.png) 0 0 no-repeat;
            background-size: cover;
            content: '';
            position: absolute;
            top: 0;
            left: 0.32rem;
        }
    }
    .jump {
        width: 50%;
        height: 0.36rem;
        position: relative;
        p {
            width: auto;
            vertical-align: middle;
            text-decoration: underline;
            padding-right: .3rem;
            color: #2f92eb;
            font-size: 0.24rem;
            height: 0.36rem;
            line-height: 0.36rem;
            text-align: right;
            font-weight: normal;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseTitle.vue